export default __webpack_public_path__ + "static/media/CosmusFitwell1.11ea20d0.jpg";